module.exports = __webpack_public_path__ + "static/media/checkedRadioButton.c807aef7.svg";